import { ServiceFetch } from '../service-fetch'

export default class StockPackListModel extends ServiceFetch {
    getStockPackListBy = (data) => this.authFetch({
        url: 'stock-pack-list/getStockPackListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}